import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ReferenceTableService} from "../reference-table.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CommonUtility, DataService, DateUtility, ServerConstantsService, WpEtEnrollment, WpPerson} from "../shared";
import {NotificationsService} from "angular2-notifications";
import {HttpClient} from "@angular/common/http";
import {Role} from "../shared/model/role.model";
import {DashboardSearch} from "../shared/model/dashboardSearch.model";
import {ContactHistory} from "../shared/model/contactHistory.model";
import { Observable } from "rxjs/Observable";
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss']
})
export class ContactDetailsComponent implements OnInit, CanComponentDeactivate {

  ServerConstants: any;
  sharedData: any;
  refData: any;
  referralId: string = '';
  wpPersonId: string = '';
  roles: Role;
  notes: string = '';
  viewOnly: boolean = false;

  maxContDate: any;
  minContDate: any;
  todayDate: any;

  userActionNotificationsMap: any;
  contactReasonCd: any;
  contactMethodCd:any;
  contactOutcomeCd: any;
  autofocus: boolean = true;
  disableSave: boolean;
  isContactReasonOther: boolean;

  contactDetails: ContactHistory;
  contactDetailsFromSummary: ContactHistory;
  contactDetailsRequest : ContactHistory;
  contactDetailsResponse: ContactHistory;
  contactDetailsPrev: ContactHistory;
  isChangeDetected: boolean;
  notesSize: number = 0;

  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;

  constructor( private route: ActivatedRoute,
               private http: HttpClient,
               private router: Router,
               private commonUtil: CommonUtility,
               private dateUtil: DateUtility,
               private data: ReferenceTableService,
               public dataService: DataService,
               private notificationService: NotificationsService,
               private serverConstantsService: ServerConstantsService,
               private modalPopupService: ModalPopupService,
               private canDeactivateGaurdService: CanDeactivateGuardService) {
    this.ServerConstants = serverConstantsService.getConstants();
    if(this.dataService.getSharedDataObject().get('CNHIS') == undefined){
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    this.parseRefTableData();
    this.dataService.globalAccess = true;
    this.sharedData = this.dataService.getSharedDataObject();
    this.contactDetails = this.sharedData.get('contact-history');
    this.contactDetailsPrev = new ContactHistory();
    if (this.contactDetails !== null && this.contactDetails !== undefined) {
      this.contactDetails.contactDt = this.dateUtil.convertDateFromServer(this.contactDetails.contactDt);
      this.viewOnly = true;
      this.notesSize = this.contactDetails.notes.length;
    } else {
      this.contactDetails = new ContactHistory();
      this.contactDetails.notes= "";
      this.contactDetailsPrev = new ContactHistory();
      this.viewOnly = false;
    }

    this.referralId = this.sharedData.get('referralId');
    this.wpPersonId = this.sharedData.get('wpPersonId')
    this.roles = this.sharedData.get('roles');

    this.isContactReasonOther = false;

    this.contactDetails.wpPersonId = parseInt( this.sharedData.get('wpPersonId')) ;
    this.contactDetailsPrev.wpPersonId = parseInt( this.sharedData.get('wpPersonId')) ;
    // if (this.contactDetails !== null) {
    //   this.contactDetailsPrev = Object.assign({}, this.contactDetails);
    // }
    this.disableSave = false;
    this.validDates();
  }

  onChange(e){
    if ( this.contactDetails.contactReasonCd == 'OT'){
      this.isContactReasonOther = true;
    }else{
      this.isContactReasonOther = false;
    }
  }

  validDates(){

    this.todayDate= new Date();
    this.minContDate = {
      month: this.todayDate.getMonth() ,
      day: this.todayDate.getDate(),
      year: this.todayDate.getFullYear()
    };
    this.maxContDate = {
      month: this.todayDate.getMonth() +1,
      day: this.todayDate.getDate(),
      year: this.todayDate.getFullYear()
    };
  }

  restrictSpecial(event){
    if((/[<>{}]/.test(event.key))){
      event.returnValue = false;
      return;
     }
      event.returnValue = true;
  }
  

  parseRefTableData(){

      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS'));
      this.contactReasonCd = this.data.getValueFromSharedDataMap("ContactReason");
      this.contactMethodCd = this.data.getValueFromSharedDataMap("ContactMethod");
      this.contactOutcomeCd = this.data.getValueFromSharedDataMap("ContactOutcome");

  }

  public gcOnQuickTextChanged($event) {
    this.notesSize = this.contactDetails.notes.length;
  }

  dataChanges() {
    this.isChangeDetected = true;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if(this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  };
  submit(){
    this.isChangeDetected=false;
    this.autofocus = false;
    // this.modalPopupService.setChangeDetected(false);
    this.contactDetailsRequest = Object.assign({}, this.contactDetails);

    if(this.contactDetailsRequest.contactDt != null){
      this.contactDetailsRequest.contactDt = this.dateUtil.convertDateForServer(
        this.contactDetailsRequest.contactDt);
    }

    this.http.post<ContactHistory> (this.ServerConstants.SERVER_API_URL + "/contact/save", this.contactDetailsRequest ).subscribe(
      (data: ContactHistory) => {
        this.contactDetailsResponse = data;

        if(data.hasOwnProperty('errorCode')){
          console.log('this.contactDetailsRequest.contactOutcomeCd ===' + this.contactDetailsRequest.contactOutcomeCd);

          if(this.contactDetailsRequest.contactOutcomeCd === 'DP' || this.contactDetailsRequest.contactOutcomeCd === 'CU') {
            this.notificationService.error('Contact History','Unable to send notification to the eligibility system; system will retry later.');   
            //this.disableSave = true;
            this.reset();
          } else {
            this.notificationService.error('Contact History', this.userActionNotificationsMap.ERROR);
            setTimeout(() => this.fileInput.nativeElement.focus(), 0);
            this.fileInput.nativeElement.click();
            this.reset();
          }          
         
        }
        else {
         if (this.contactDetailsResponse.id != null) {
           this.notificationService.success('Contact History', this.userActionNotificationsMap.UPDATE);
           setTimeout(() => this.headerText.nativeElement.focus(), 0);
           this.headerText.nativeElement.click();

           this.disableSave = true;

           this.loadContactHistory();
         }
        }
      },
      response => {
        if(this.contactDetailsRequest.contactOutcomeCd === 'DP' || this.contactDetailsRequest.contactOutcomeCd === 'CU') {
          this.notificationService.error('Contact History','Unable to send notification to the eligibility system; system will retry later.');   
          //this.disableSave = true;
          this.reset();
        } else {
          this.notificationService.error('Contact History', this.userActionNotificationsMap.ERROR);
          setTimeout(() => this.fileInput.nativeElement.focus(), 0);
          this.fileInput.nativeElement.click();
          this.reset();
        }  
      },
      () => {
      });
  }

  loadContactHistory() {
    this.router.navigate(['task/contactSummary']);
  }

  reset() {
    this.contactDetails.contactMethodCd = undefined;
    this.contactDetails.contactReasonCd = undefined;
    this.contactDetails.contactDt = null;
    this.contactDetails.contactOutcomeCd = undefined;
    this.contactDetails.notes = "";
  }

  focusing(e) {
    if (e.keyCode === 9  && !e.shiftKey) {
      setTimeout(() => this.fileInput.nativeElement.focus(), 0);
      this.fileInput.nativeElement.click();
    }
  }

  focusHeader(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      e.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/contact-details/contact-details.component.ts